<div class="sb-button-view-only-container" [class.sb-button-view-only]="isViewOnly">
    @if (iconOnly) {
        <lib-icon-button
            [icon]="prefixIcon"
            [kind]="kind"
            [size]="size"
            [active]="active"
            [disabled]="disabled"
            [loading]="loading"
            [isViewOnly]="isViewOnly"
            [qaTag]="qaTag"
            [ariaLabel]="ariaLabel"
            [ariaExpanded]="ariaExpanded"
            [toolTipText]="toolTipText"
            [menuTrigger]="menuTrigger"
            [badgeText]="badgeText"
            [stopPropagation]="stopPropagation"
            (clicked)="clicked.emit($event)"
            (pressed)="pressed.emit()"
            (menuClosed)="menuClosed.emit()">
            <ng-container profile *ngTemplateOutlet="profileTemplate"></ng-container>
        </lib-icon-button>
    }

    @if (!iconOnly && !isLinkKind && !urlLink) {
        <div panelTrigger>
            <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
        </div>
    }

    @if (!iconOnly && isLinkKind && !urlLink) {
        <button
            type="button"
            class="border-0"
            [ngClass]="buttonClass"
            [attr.aria-label]="ariaLabel || null"
            [attr.data-sb-qa]="qaTag"
            [matMenuTriggerFor]="menuTrigger"
            #optionsMenuTrigger="matMenuTrigger"
            (menuClosed)="MenuClosed()"
            (click)="ButtonClicked($event, optionsMenuTrigger)"
            (mousedown)="ButtonPressed($event)">
            <div>
                <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
            </div>
        </button>
    }

    @if (!iconOnly && !isLinkKind && urlLink) {
        <a
            [href]="urlLink | trustUrl"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-current]="ariaCurrent"
            [attr.data-sb-qa]="qaTag"
            [ngClass]="buttonClass"
            [matTooltip]="toolTipText"
            matTooltipPosition="below"
            routerLinkActive="active"
            target="_blank"
            (click)="ButtonClicked($event)">
            <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
        </a>
    }

    @if (!iconOnly && isLinkKind && urlLink) {
        <a
            class="border-0"
            [ngClass]="buttonClass"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-current]="ariaCurrent"
            [attr.data-sb-qa]="qaTag"
            (click)="ButtonClicked($event)"
            [href]="urlLink | trustUrl"
            routerLinkActive="active"
            target="_blank">
            <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
        </a>
    }

    @if (isViewOnly) {
        <div class="sb-button-view-only-overlay"></div>
    }
</div>
<ng-template #labelTemplate>
    <div
        class="sb-button-label-wrapper">
        @if (prefixIcon) {
            <lib-icon
                [ngClass]="{ '': !iconOnly, invisible: loading}"
                [qaTag]="qaTag ? qaTag + '-prefix-icon-' + prefixIcon.Name : ''"
                class="sb-button-prefix-icon"
                [ngClass]="{ invisible: loading }"
                [icon]="prefixIcon"
                [size]="iconSize"></lib-icon>
        }


        <span
            #label
            [ngClass]="{ invisible: loading, 'sb-button-label-truncate': truncate}"
            [matTooltip]="label.textContent"
             matTooltipPosition="right"
            [matTooltipDisabled]="!isLabelTruncated || (truncate && !isLinkKind)"  
            class="sb-button-label"
            [class.text-nowrap]="!allowTextWrap">
            <ng-content select="[label]"></ng-content>
        </span>
      

        @if (loading) {
            <span class="sb-button-spinner" aria-hidden="true"></span>
        }
        @if (suffixIcon) {
            <lib-icon
                [qaTag]="qaTag ? qaTag + '-suffix-icon-' + suffixIcon.Name : ''"
                class="sb-button-suffix-icon"
                [ngClass]="{ invisible: loading }"
                [icon]="suffixIcon"
                [size]="iconSize"></lib-icon>
        }
    </div>
</ng-template>

<ng-template #buttonTemplate>
    <div
        class="position-relative d-inline-flex"
        [class.w-100]="stretch">
        <button
            #button
            [matMenuTriggerFor]="menuTrigger"
            #optionsMenuTrigger="matMenuTrigger"
            type="submit"
            [ngClass]="buttonClass"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-expanded]="ariaExpanded"
            [attr.data-sb-qa]="qaTag"
            [matTooltip]="toolTipText"
            matTooltipPosition="below"
            (menuClosed)="MenuClosed()"
            (mousedown)="ButtonPressed($event)"
            (click)="ButtonClicked($event, optionsMenuTrigger)">
            <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
        </button>
        @if (badgeText) {
            <lib-badge
                class="position-absolute sb-button-badge"
                [style.top.px]="-12"
                [style.left.%]="100"
                [style.margin-left.px]="-16"
                [kind]="BadgeKind.Count"
                [text]="badgeText">
            </lib-badge>
        }
    </div>
</ng-template>

<ng-template #profileTemplate>
    <ng-content select="[profile]"></ng-content>
</ng-template>

<ng-content select="[panel]"></ng-content>
